<template>
  <ModalContainer :show="show">
    <template slot="body">
      <div class="modal-content">
        <div class="d-flex align-items-center justify-content-end">
          <img
            src="../../assets/images/Vector (1).png"
            alt="close"
            class="cursor-pointer mt-1 mr-1"
            @click="$emit('close')"
          />
        </div>

        <div
          class="d-flex flex-column align-items-center justify-contents-center body"
        >
          <img
            src="../../assets/images/fluent-mdl2_bulk-upload.svg"
            alt=""
            class="w-30"
          />

          <p
            class="mt-3 font-20 font-weight-bolder"
            style="text-transform: capitalize; text-align: center"
          >
            {{ heading }}
          </p>

          <p class="font-14 text-center">
            <span class="gray4" :class="msgWidth">
              {{ msg }}
            </span>
            <span
              style="
                color: rgba(33, 62, 122, 1);
                font-weight: 600;
                text-decoration: underline;
              "
              @click="triggerFileUpload"
              class="cursor-pointer"
            >
              {{ span }}
            </span>
            .
            <input
              class="d-none"
              accept=".csv"
              id="upload_csv"
              type="file"
              @change="handleFileUpload"
              ref="fileInput"
            />
          </p>

          <!-- Show uploaded file name here -->
          <p v-if="fileName" class="mt-2 font-14 text-center">
            <strong>File Name:</strong> {{ fileName }}
          </p>

          <div
            style="
              padding: 16px;
              box-shadow: 0px 4px 16px rgba(12, 12, 13, 0.08);
              border-radius: 8px;
              display: flex;
              align-items: center;
              gap: 0.3rem;
            "
            class="mb-3"
          >
            <img src="../../assets/images/csv 1.svg" />
            <span>
              <span> Click </span>
              <span
                style="color: rgba(33, 62, 122, 1); text-decoration: underline"
                @click="downloadCSVTemplateSea"
                class="cursor-pointer"
              >
                here
              </span>
              <span> to download CSV Template for Sea Freight Shipment </span>
            </span>
          </div>

          <!-- Download CSV Template -->
          <div
            style="
              padding: 16px;
              box-shadow: 0px 4px 16px rgba(12, 12, 13, 0.08);
              border-radius: 8px;
              display: flex;
              align-items: center;
              gap: 0.3rem;
            "
          >
            <img src="../../assets/images/csv 1.svg" />
            <span>
              <span> Click </span>
              <span
                style="color: rgba(33, 62, 122, 1); text-decoration: underline"
                @click="downloadCSVTemplateAir"
                class="cursor-pointer"
              >
                here
              </span>
              <span> to download CSV Template for Air Freight Shipment </span>
            </span>
          </div>

          <div
            class="mt-4 d-flex justify-contents-between align-items-center col-gap-2 w-100"
          >
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="handleUpload"
              :disabled="!parsedData.length"
            >
              {{ action }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </ModalContainer>
</template>

<script>
import loadGoogleMapsApi from "load-google-maps-api";
import ModalContainer from "../../components/ModalContainer";
import Papa from "papaparse";
import { mapActions } from "vuex";

export default {
  name: "UploadFileModal",
  components: {
    ModalContainer,
  },
  props: {
    show: Boolean,
    heading: String,
    msg: String,
    span: String,
    action: String,
    msgWidth: {
      type: String,
      default: "msg_default",
    },
  },
  data() {
    return {
      parsedData: [],
      geocoder: null,
      fileName: "",
    };
  },
  methods: {
    ...mapActions(["uploadBulkShipment"]),
    close() {
      this.$emit("close");
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleLoading(isLoading) {
      this.$emit("isLoading", isLoading);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;
        Papa.parse(file, {
          header: true,
          complete: this.processCSVData,
          skipEmptyLines: 'greedy',
        });
      }
    },
    processCSVData(result) {
      // Remove rows where every field is empty or whitespace
      const data = result.data.filter(row =>
        Object.values(row).some(val => val && val.toString().trim() !== '')
      );
      this.parsedData = data.map((row) => {
        return {
          shipmentType: row["Flight Number"] ? "air" : "sea",
          flightNumber: row["Flight Number"] || undefined,
          awb: row["Air Waybill Number"] || undefined,
          isScheduledReport: row["Scheduled Report"] === "Yes" ? true : false,
          schedule: row["Schedule Report Period"] || undefined,

          containers: [
            {
              containerNumber: row["Container Number"] || "",
              product: row["Product"] || "",
              pallet: row["No of Pallet"] || "",
              assignedDevices: row["Devices IMEI"]
                ? row["Devices IMEI"].replace(/\s+/g, "").split(/[,;]/)
                : [],
            },
          ],

          reference: row["Reference Number"] || "",
          vesselName: row["Vessel Name"] || undefined,
          eta: this.formatDate(row["ETA"]),
          pointOfArrival: row["Point of Arrival"] || "",
          pointOfDeparture: row["Point of Discharge"] || "",
          loadingDate: this.formatDate(row["Loading Date"]),
          departureDate: this.formatDate(row["Departure Date"]),
          originInfo: {
            country: row["Origin Country"] || "",
            entry: "port",
            port: row["Origin Port"] || "",
            personOfContact: row["Origin Phone Number"] || "",
          },
          destinationInfo: {
            personOfContact: row["Destination Phone Number"] || "",
            country: row["Destination Country"] || "",
            entry: "port",
            port: row["Destination Port"] || "",
          },
          emailUsers: row["Users Email"]
            ? row["Users Email"].replace(/\s+/g, "").split(/[,;]/)
            : [],
          partner: row["Shipment Partner"] || "",
        };
      });

      // Now, geocode the addresses
      this.geocodeAddresses();
    },
    formatDate(dateString) {
      if (!dateString) return null;

      const parsedDate = new Date(dateString);

      if (isNaN(parsedDate.getTime())) {
        const parts = dateString.split(/[\/\-\s:]/);
        if (parts.length >= 3) {
          const year = parts[2].length === 4 ? parts[2] : parts[0];
          const month = parts[1] - 1;
          const day = parts[0].length === 2 ? parts[0] : parts[2];
          const hours = parts[3] ? parts[3] : "00";
          const minutes = parts[4] ? parts[4] : "00";
          const seconds = parts[5] ? parts[5] : "00";

          const customParsedDate = new Date(
            year,
            month,
            day,
            hours,
            minutes,
            seconds
          );
          return isNaN(customParsedDate.getTime())
            ? null
            : customParsedDate.toISOString();
        }

        return null;
      }

      return parsedDate.toISOString();
    },
    geocodeAddresses() {
      this.parsedData.forEach((entry, index) => {
        const originAddress = `${entry.originInfo.address.name}, ${entry.originInfo.region}, ${entry.originInfo.country}`;
        this.geocodeAddress(originAddress, (lat, lng) => {
          this.$set(this.parsedData[index].originInfo.address, "lat", lat);
          this.$set(this.parsedData[index].originInfo.address, "lng", lng);
        });

        const destinationAddress = `${entry.destinationInfo.address.name}, ${entry.destinationInfo.region}, ${entry.destinationInfo.country}`;
        this.geocodeAddress(destinationAddress, (lat, lng) => {
          this.$set(this.parsedData[index].destinationInfo.address, "lat", lat);
          this.$set(this.parsedData[index].destinationInfo.address, "lng", lng);
        });
      });
    },
    geocodeAddress(address, callback) {
      if (this.geocoder) {
        this.geocoder.geocode({ address }, (results, status) => {
          if (
            status === window.google.maps.GeocoderStatus.OK &&
            results.length > 0
          ) {
            const result = results[0];
            const latLng = result.geometry.location;
            callback(latLng.lat(), latLng.lng());
          } else {
            console.error("Geocoding failed:", status);
            callback(0, 0);
          }
        });
      } else {
        console.error("Geocoder not initialized.");
        callback(0, 0);
      }
    },
    handleUpload() {
      this.handleLoading(true);
      this.uploadBulkShipment({ items: this.parsedData })
        .then(() => {
          this.handleLoading(false);
          this.close();
          this.$emit("showFileUploadSuccess");
        })
        .catch(() => {
          this.handleLoading(false);
        });
    },
    downloadCSVTemplateSea() {
      this.handleLoading(true);

      // Define CSV headers exactly as in the uploaded file
      const csvHeaders =
        "Vessel Name,Departure Date,Loading Date,ETA,Point of Arrival,Reference Number,Point of Discharge,Product,No of Pallet,Container Number,Devices IMEI,Origin Country,Origin Port,Origin Phone Number,Destination Country,Destination Port,Destination Phone Number,Scheduled Report,Schedule Report Period,Users Email\n";

      // Sample row matching the exact data from the provided CSV
      const sampleRow =
        "Oceanic Voyager,2025-03-26,2025-03-25,2025-03-31,New York Port,SEA1234,Tin Can Sea Port,Electronics,10,C12345,190124040001219; 180322000003909,China,Shanghai Port,817689890,USA,New York Port,8179890890,YES,24hrs,manager@logistics.com; coordinator@logistics.com\n";

      // Concatenate header and sample row
      const fullCsvContent = csvHeaders + sampleRow;

      // Create a Blob from the CSV content
      const blob = new Blob([fullCsvContent], {
        type: "text/csv;charset=utf-8;",
      });

      // Create a download link and trigger the download
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "sea-shipping-csv-template.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      this.handleLoading(false);
    },
    downloadCSVTemplateAir() {
      this.handleLoading(true);

      const csvHeaders =
        "Flight Number,Departure Date,Loading Date,ETA,Point of Arrival,Reference Number,Point of Discharge,Product,No of Pallet,Air Waybill Number,Devices IMEI,Origin Country,Origin Port,Origin Phone Number,Destination Country,Destination Port,Destination Phone Number,Scheduled Report,Schedule Report Period,Users Email\n";

      const sampleRow =
        "FL1234,2025-03-26,2025-03-25,2025-03-31,John F. Kennedy Airport,AIR7890,Shanghai Pudong Airport,Electronics,5,AWB123456789,190124040001219; 180322000003909,China,Shanghai Pudong Airport,817689890,USA,John F. Kennedy Airport,8179890890,YES,24hrs,manager@logistics.com; coordinator@logistics.com\n";

      const fullCsvContent = csvHeaders + sampleRow;

      const blob = new Blob([fullCsvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "air-shipping-csv-template.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      this.handleLoading(false);
    },
  },
  watch: {
    parsedData: {
      handler() {
        console.log(this.parsedData, "this.parsedData");
      },
      deep: true,
    },
  },
  created() {
    loadGoogleMapsApi({
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "drawing", "geometry"],
    }).then(() => {
      if (window.google && window.google.maps) {
        this.geocoder = new window.google.maps.Geocoder();
      } else {
        console.error("Google Maps API not loaded.");
      }
    });
  },
};
</script>

<style scoped>
.modal-content {
  width: 100%;
  max-height: 72vh;
}
.body {
  padding: 10px 50px;
}
@media (max-width: 575.98px) {
  .modal-content {
    width: 100% !important;
  }
  .body {
    padding: 25px;
  }
}
</style>
